import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { FreyaCommonModule } from '../../../../freya-common/freya-common.module';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-dispatch-tooltip',
  standalone: true,
  imports: [CommonModule, FreyaCommonModule, SharedModule],
  templateUrl: './dispatch-tooltip.component.html',
  styleUrls: ['./dispatch-tooltip.component.scss']
})
export class DispatchTooltipComponent {
  @Input() name: string = '';
  @Input() imageUrl: string = '';
  @Input() icon: string = '';
  @Input() eventsCount: number | null = null;
  @Input() revenue: number | null = null;
  @Input() panelType: 'left' | 'right' | 'dialog' = 'right';
  @Input() text: string = '';
}
